import { MagistralDrugTemplateQuery } from '@dreryk/drerykweb-medicine-api';

import { performCqrsQueryExists } from '@dreryk/command-query-react-common';
import { TranslatableText, ValidationRules } from '@dreryk/react-common';
import { TextInput } from '@dreryk/react-components';
import { Slot } from '@dreryk/watermelon';

import { FormsTemplates } from '~libs.desktop.shared.user-templates.forms';

import { magistralDrugTemplatesTranslationKeys } from '../../../../../translations';
import {
   MagistralDrugCreateFormBean,
   MagistralDrugCreateFormController,
} from '../../../magistralDrug/create/MagistralDrugCreateForm.types';
import { MagistralDrugTemplateListItem } from '../MagistralDrugTemplates.types';

type TemplateNameTextInputProps = Pick<MagistralDrugCreateFormController, 'register'> & {
   readonly template: MagistralDrugTemplateListItem | undefined;
};

const useValidationRules = (
   template: MagistralDrugTemplateListItem | undefined
): ValidationRules<MagistralDrugCreateFormBean> => {
   const validate = async (data: unknown): Promise<TranslatableText | undefined> => {
      const currentName = data as string | null;
      if (currentName) {
         const currentNameOccupied = await performCqrsQueryExists(() => {
            const query = new MagistralDrugTemplateQuery();
            query.name = Slot.of(currentName);
            return query;
         });
         if (currentNameOccupied) {
            return magistralDrugTemplatesTranslationKeys.templateNameOccupied;
         }
      }
      return undefined;
   };
   return {
      maxLength: 200,
      required: true,
      validate: FormsTemplates.isItemEmpty(template) ? validate : undefined,
   };
};

export const MagistralDrugTemplateTemplateNameTextInput = (props: TemplateNameTextInputProps): JSX.Element => {
   return (
      <TextInput
         label={magistralDrugTemplatesTranslationKeys.name}
         testId={'templateName'}
         controller={props.register('drugName', useValidationRules(props.template))}
      />
   );
};
